import React, { useEffect } from "react";
import "./features.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBolt,
  faLeaf,
  faMobileAlt,
  faShieldAlt,
  faTruckFast,
  faRecycle,
  faHeadset,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";


export default function Features() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Features - Why Shop With Us</title>
        <meta
          name="description"
          content="Discover the powerful features of SHOP.CO, including advanced filtering, category browsing, and personalized shopping for a better experience."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/company/features/"
        />
      </Helmet>
      <div className="features-page">
        <h1 className="features-title">Our Features</h1>
        <p className="features-subtitle">
          Discover what makes our platform unique and valuable for you.
        </p>

        <div className="features-grid">
          <div className="feature-card">
            <FontAwesomeIcon icon={faBolt} className="feature-icon" />
            <h3>Fast Performance</h3>
            <p>Blazing fast site and smooth experience.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faLeaf} className="feature-icon" />
            <h3>Eco Friendly</h3>
            <p>We follow green and sustainable operations.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faMobileAlt} className="feature-icon" />
            <h3>Mobile Ready</h3>
            <p>Works perfectly on all mobile devices.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faShieldAlt} className="feature-icon" />
            <h3>Secure Shopping</h3>
            <p>Your data and payments are safe with us.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faTruckFast} className="feature-icon" />
            <h3>Fast Delivery</h3>
            <p>Get your orders quickly with our reliable delivery.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faRecycle} className="feature-icon" />
            <h3>Easy Returns</h3>
            <p>Simple and flexible return policy for peace of mind.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faHeadset} className="feature-icon" />
            <h3>24/7 Support</h3>
            <p>Our team is always here to help you anytime.</p>
          </div>

          <div className="feature-card">
            <FontAwesomeIcon icon={faStar} className="feature-icon" />
            <h3>Top Quality</h3>
            <p>Only the best products carefully selected for you.</p>
          </div>
        </div>
      </div>
    </>
  );
}
